<template v-if="data.type === 'events'">
	<div class="chiv--16 date-time-block text-bold">
		<span v-if="startDate.format(dateFormat)" class="start-date">
			{{ startDate.format(dateFormat) }}
		</span>
		<span class="different-date" v-if="endDate && startDate !== endDate">
			<span class="sep">-</span>
			<span class="end-date" v-if="startDate.format(dateFormat) !== endDate.format(dateFormat)">
				{{ endDate.format(dateFormat) }}
			</span>
		</span>

		<template v-if="startDate.format(dateFormat) === endDate.format(dateFormat)">
			(
			<span v-if="startDate.format(timeFormat) !== '00:00'" class="start-hour">
				{{ startDate.format(timeFormat) }}
			</span>

			<span class="end-hour" v-if="endDate && startDate !== endDate && endDate.format(timeFormat) !== '00:00'">
				<span class="sep">•</span>
				{{ endDate.format(timeFormat) }}
			</span>
			)
		</template>
		<div class="event-category text-uppercase chiv--16" v-if="eventCategory && eventCategory.name">
			{{ eventCategory.name }}
		</div>
	</div>
</template>

<script>
import moment from 'moment'
moment.locale('nb-NO')
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			dateFormat: 'D. MMMM YYYY',
			timeFormat: 'HH:mm',
			startDate: '',
			endDate: '',
		}
	},
	props: {
		data: {
			type: Object,
			default: {},
		},
	},
	created() {
		this.startDate = this.data.acf.start_date ? moment(this.data.acf.start_date) : false
		this.endDate = this.data.acf.end_date ? moment(this.data.acf.end_date) : false
	},
	computed: {
		...mapGetters(['storedTaxonomy']),
		eventCategory() {
			const categoryList = this.storedTaxonomy('event_category')
			if (categoryList && categoryList.length && this.data && this.data.acf && this.data.acf.kurs_type) {
				return categoryList.find((e) => Number(e.id) === Number(this.data.acf.kurs_type))
			}
			return false
		},
	},
}
</script>

<style lang="scss">
.date-time-block {
	margin-bottom: 10px;
	display: flex;
	.sep {
		margin-left: 5px;
		margin-right: 5px;
		display: inline-block;
	}
	.event-category {
		flex-grow: 1;
		text-align: right;
	}
}
</style>
